<template>
    <div>
        <Head>
            <title>{{ campaignName }}</title>
            <meta name="description" :content="metaDescription" />
            <meta name="keywords" :content="metaKeywords" />
        </Head>
        <Cms
            :readable-fields="['metaDescription', 'metaKeywords','campaignName']"
            model="campaign-content"
            driver="builder"
            :components="getBuilderComponents()"
            is-section
            :search-params="campaignParams"
            content-prop="content"
            v-model="builderData"
        />
    </div>
</template>
<script setup lang="ts">
    import Cms from "@/components/Cms.vue";
    import { computed, ref } from "vue";
    // import { registeredComponents } from "../../campaign-page-init-builder.ts";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { Head } from "@inertiajs/vue3";
    let props = defineProps({
        campaign_name: {
            type: String,
            required: true
        },
        content: {
            type: Object,
            default: () => ({
                data: {
                    campaignName: null,
                    metaDescription: "",
                    metaKeywords: ""
                }
            })
        }
    });

    let campaignParams = computed(()=>{
        return {
            'data.campaignUrl.$eq': props.campaign_name,
        }
    })

    let builderData = ref({
        campaignName: null,
        metaDescription: "",
        metaKeywords: ""
    })

    let campaignName = computed(()=>{
        return props.content?.data?.campaignName ?? builderData.value?.campaignName;
    })

    let metaDescription = computed(()=>{
        return props.content?.data?.metaDescription ?? builderData.value?.metaDescription;
    })

    let metaKeywords = computed(()=>{
        return props.content?.data?.metaKeywords ?? builderData.value?.metaKeywords;
    })
</script>
